import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth, postAuthDestination } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, setUser, loading } = useAuth() || {};
  const [checked, setChecked] = useState(!!user);

  // Gate every protected route through the same rules as post-login
  // routing: unverified email or unapproved staff account gets bounced to
  // the appropriate holding page.
  useEffect(() => {
    if (!user) return;
    const dest = postAuthDestination(user);
    const holdingPages = ["/account/verify-email", "/account/pending-verification", "/account/reset-password", "/onboarding/profile"];
    if (holdingPages.includes(dest) && !location.pathname.startsWith(dest)) {
      navigate(dest, { replace: true });
    }
  }, [user, location.pathname, navigate]);

  useEffect(() => {
    if (user) { setChecked(true); return; }
    if (loading) return;
    // skip check if returning from OAuth callback
    if (window.location.hash?.includes("session_id=")) return;
    const run = async () => {
      try {
        const r = await api.get("/auth/me");
        setUser?.(r.data);
        setChecked(true);
      } catch (e) {
        navigate("/login", { state: { from: location.pathname } });
      }
    };
    run();
  }, [user, loading, navigate, location.pathname, setUser]);

  if (loading || !checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-kb-bg" data-testid="protected-loading">
        <div className="kb-mono text-xs uppercase tracking-[0.2em] text-kb-ink-muted">
          Loading workspace…
        </div>
      </div>
    );
  }
  return children;
}
